import { OPP_EMOJI, OPP_COLOR } from "../constants/opportunities";

export function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function mapOpportunity(row) {
  const deadline = row.deadline ? new Date(row.deadline + 'T00:00:00') : null;
  const daysLeft = deadline ? Math.ceil((deadline - new Date()) / 86400000) : 0;
  const entryFee = row.entry_fee_type === 'free' ? 'Free'
    : row.entry_fee_amount ? `$${Number(row.entry_fee_amount).toFixed(0)} AUD` : 'Free';
  const exhibitionDates = row.exhibition_start && row.exhibition_end
    ? `${formatDate(row.exhibition_start)} – ${formatDate(row.exhibition_end)}`
    : 'Flexible';
  return {
    id: row.id,
    type: row.type,
    org: row.org_name,
    location: row.location || 'Australia',
    title: row.title,
    theme: row.theme || '',
    exhibitionDates,
    deadline: formatDate(row.deadline),
    daysLeft,
    deadlineTime: row.deadline_time || '5:00 pm AEST',
    mediums: row.mediums || [],
    entryFee,
    entry_fee_type: row.entry_fee_type || 'free',
    entry_fee_amount: row.entry_fee_amount ? Number(row.entry_fee_amount) : 0,
    prize: row.prize || 'N/A',
    commission: row.commission || 'N/A',
    maxDimensions: row.max_dimensions || 'N/A',
    eligibility: row.eligibility || 'Australian-based artists',
    abn: row.abn_required,
    color: OPP_COLOR[row.type] || '#d4c5a9',
    tag: row.tag || 'open',
    emoji: OPP_EMOJI[row.type] || '🎨',
    state: row.state,
    consignment_offered: row.consignment_offered || false,
    consignment_duration: row.consignment_duration || null,
    damage_policy: row.damage_policy || null,
    return_shipping: row.return_shipping || null,
    payment_terms: row.payment_terms || null,
    external_url: row.external_url || null,
    source: row.source || 'self_onboarded',
  };
}

export function mapArtist(row) {
  const name = row.display_name || row.full_name || 'Artist';
  const initials = name.split(' ').filter(Boolean).map(w => w[0]).join('').slice(0,2).toUpperCase() || 'A';
  return {
    id: row.id,
    name,
    title: row.bio ? row.bio.split('.')[0].slice(0,60) : 'Artist',
    location: row.location || 'Australia',
    mediums: row.mediums || [],
    color: '#d4c5a9',
    av: initials,
    shows: row.exhibition_history ? (() => { try { return JSON.parse(row.exhibition_history).length; } catch { return 0; } })() : 0,
    firstNations: row.first_nations || false,
    bio: row.bio || '',
    portfolioImages: (row.portfolio_images || [])
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
      .map(img => img.image_url),
  };
}

export function profileInitials(profile) {
  if (!profile) return '?';
  const name = profile.display_name || profile.full_name || '';
  return name.split(' ').filter(Boolean).map(w => w[0]).join('').slice(0,2).toUpperCase() || '?';
}
